// useState, useContext,
import React, { useContext, useRef } from 'react';

import useInput from '../hooks/useInput';

import Container from '@mui/system/Container';

import { Box, Button, Typography, Modal, TextField }  from '@mui/material';

import AuthContext from '../contexts/AuthContext';

export default function SignUpModal(props = {}) {
  const authContext = useContext(AuthContext);

  const usernameInputRef = useRef();
  const emailInputRef = useRef(); 
  const passwordInputRef = useRef();
  const confirmPasswordInputRef = useRef();

  const isNotEmpty = (value) => value.trim() !== '';
  const isNotEmptyAndEqualTo = (value) => value.trim() !== '' && passwordValue === value;
  const isEmail = (value) => value.includes('@');
  const isUsername = (value) =>  !!/^[a-z0-9_\.]+$/.exec(value);

  const handleLoginModalOpen = () => {
    props.handleSignUpClose();
    props.handleLoginOpen();
  }

  const {
    value: usernameValue,
    isValid: usernameIsValid,
    hasError: usernameHasError,
    valueChangeHandler: usernameChangeHandler,
    valueTouchHandler: usernameTouchHandler,
    valueErrorHandler: usernameErrorHandler,
    inputBlurHandler: usernameBlurHandler,
    reset: resetUsername,
  } = useInput(isUsername);
  const {
    value: emailValue,
    isValid: emailIsValid,
    hasError: emailHasError,
    valueChangeHandler: emailChangeHandler,
    valueTouchHandler: emailTouchHandler,
    valueErrorHandler: emailErrorHandler,
    inputBlurHandler: emailBlurHandler,
    reset: resetEmail,
  } = useInput(isEmail);
  const {
    value: passwordValue,
    isValid: passwordIsValid,
    hasError: passwordHasError,
    valueChangeHandler: passwordChangeHandler,
    valueTouchHandler: passwordTouchHandler,
    valueErrorHandler: passwordErrorHandler,
    inputBlurHandler: passwordBlurHandler,
    reset: resetPassword,
  } = useInput(isNotEmpty);
  const {
    value: confirmPasswordValue,
    isValid: confirmPasswordIsValid,
    hasError: confirmPasswordHasError,
    valueChangeHandler: confirmPasswordChangeHandler,
    valueTouchHandler: confirmPasswordTouchHandler,
    valueErrorHandler: confirmPasswordErrorHandler,
    inputBlurHandler: confirmPasswordBlurHandler,
    reset: resetConfirmPassword,
  } = useInput(isNotEmptyAndEqualTo);

  let formIsValid = false;

  if (emailIsValid && passwordIsValid && confirmPasswordIsValid && usernameIsValid) {
    formIsValid = true;
  }

  const submitHandler = async (event) => {
    event.preventDefault();

    if (formIsValid) {
      const state = await authContext.onSignUp(usernameValue, emailValue, passwordValue);
      if (state) {
        props.handleSignUpClose();
        resetUsername();
        resetPassword();
        resetConfirmPassword();
        resetEmail();
      } else {
        usernameErrorHandler();
        emailErrorHandler();
      }
      //setLoginFail(authContext.onLogin(emailValue, passwordValue));
    } else {
      return;
    } //else if (!emailIsValid) {
      //#region emailInputRef.current.focus();
    //} else {
      //passwordInputRef.current.focus();
    //}
  };

  const usernameEnablesCredentials = (event) => {
    emailTouchHandler();
    usernameChangeHandler(event);
  }

  const emailEnablesCredentials = (event) => {
    usernameTouchHandler();
    emailChangeHandler(event);
  }

  const passwordEnablesCredentials = (event) => {
    usernameTouchHandler();
    emailTouchHandler();
    passwordChangeHandler(event);
  }

  const confirmPasswordEnablesCredentials = (event) => {
    usernameTouchHandler();
    emailTouchHandler();
    passwordTouchHandler();
    confirmPasswordChangeHandler(event);
  }

  return (
    <div>
      <Modal
        open={props.signUpOpen}
        onClose={props.handleSignUpClose}
        aria-labelledby="signup-modal-title"
        aria-describedby="signup-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4
        }}>
          <div>
            <Typography id="signup-modal-title" level="h4" component="h1"><b>Welcome Aboard!</b></Typography>
            <Typography id="signup-modal-description" level="body2" sx={{ mt: 1 }}>Sign Up to continue</Typography>
          </div>
          <form onSubmit={submitHandler}>
            <Container
              sx={{ flexDirection: "column", display: "flex" }}
            >
              <TextField
                ref={usernameInputRef}
                name="username"
                type="username"
                placeholder="johndoe"
                label="Username"
                sx={{ mt: 3 }}
                value={usernameValue}
                onChange={usernameEnablesCredentials}
                onBlur={usernameBlurHandler}
                error={usernameHasError}
                helperText={emailHasError && "Invalid Username."}
              />
              <TextField
                ref={emailInputRef}
                name="email"
                type="email"
                placeholder="johndoe@email.com"
                label="Email"
                sx={{ mt: 3 }}
                value={emailValue}
                onChange={emailEnablesCredentials}
                onBlur={passwordBlurHandler}
                error={emailHasError}
                helperText={emailHasError && "Invalid Email."}
              />
              <TextField
                ref={passwordInputRef}
                name="password"
                type="password"
                placeholder="password"
                label="Password"
                sx={{ mt: 3 }}
                value={passwordValue}
                onChange={passwordEnablesCredentials}
                onBlur={emailBlurHandler}
                error={passwordHasError}
              />
              <TextField
                ref={confirmPasswordInputRef}
                name="confirm-password"
                type="password"
                placeholder="confirm password"
                label="Confirm Password"
                sx={{ mt: 3 }}
                value={confirmPasswordValue}
                onChange={confirmPasswordEnablesCredentials}
                onBlur={confirmPasswordBlurHandler}
                error={confirmPasswordHasError}
              />
            </Container>
            <Container 
              sx={{ mt: 2, flexDirection: "row-reverse", display: "flex" }}
            >
              <Button sx={{ mt: 1 }} type="submit" disabled={!formIsValid}>Sign Up</Button>
              <Typography
                fontSize="sm"
                sx={{ mt: 1.5, mr: 1 }}
                onClick={handleLoginModalOpen}
              >
                Log In
              </Typography>
            </Container>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
